import './Login.css';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../services/firebase';

export default function Login({ onGoSignup }) {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [mode, setMode] = useState('login');
  const [error, setError] = useState('');
  const [loggingIn, setLoggingIn] = useState(false);
  const [sending, setSending] = useState(false);
  const [resetSent, setResetSent] = useState(false);

  const login = async () => {
    setError('');
    setLoggingIn(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      console.error(err);
      setError(t('auth.errors.login'));
    } finally {
      setLoggingIn(false);
    }
  };

  const sendReset = async () => {
    setError('');
    setSending(true);
    try {
      await sendPasswordResetEmail(auth, email);
      setResetSent(true);
    } catch (err) {
      console.error(err);
      setError(t('auth.errors.reset'));
    } finally {
      setSending(false);
    }
  };

  const goToReset = () => {
    setMode('reset');
    setError('');
    setResetSent(false);
  };

  const goToLogin = () => {
    setMode('login');
    setError('');
    setResetSent(false);
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <div className="login-brand">
          <svg viewBox="0 0 32 32" aria-hidden="true">
            <rect width="32" height="32" rx="8" fill="#16C47F" />
            <path d="M8 8h16a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3h-6l-5 4v-4H8a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3z" fill="#07241A" />
          </svg>
          Yunoo <span className="login-chip">ADMIN</span>
        </div>

        {mode === 'login' ? (
          <>
            <h2>{t('auth.loginTitle')}</h2>
            <p className="login-sub">{t('auth.loginSubtitle')}</p>
            <input
              className="field"
              type="email"
              placeholder={t('auth.email')}
              value={email}
              onChange={e => setEmail(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && login()}
            />
            <input
              className="field"
              type="password"
              placeholder={t('auth.password')}
              value={password}
              onChange={e => setPassword(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && login()}
            />
            {error && <p className="login-error">{error}</p>}
            <button className="btn btn-primary login-submit" onClick={login} disabled={loggingIn}>
              {loggingIn ? t('auth.signingIn') : t('auth.signIn')}
            </button>
            <p className="login-alt">
              <button type="button" className="login-link" onClick={goToReset}>{t('auth.forgotPassword')}</button>
            </p>
            <p className="login-alt">
              {t('auth.noAccount')} <button type="button" onClick={onGoSignup}>{t('auth.createFree')}</button>
            </p>
          </>
        ) : (
          <>
            <h2>{t('auth.resetTitle')}</h2>
            <p className="login-sub">{t('auth.resetSubtitle')}</p>
            {resetSent ? (
              <p className="login-success">{t('auth.resetSent')}</p>
            ) : (
              <>
                <input
                  className="field"
                  type="email"
                  placeholder={t('auth.email')}
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && sendReset()}
                />
                {error && <p className="login-error">{error}</p>}
                <button className="btn btn-primary login-submit" onClick={sendReset} disabled={sending}>
                  {sending ? t('auth.sendingReset') : t('auth.sendResetLink')}
                </button>
              </>
            )}
            <p className="login-alt">
              <button type="button" onClick={goToLogin}>{t('auth.backToLogin')}</button>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
